"use client";
import { createSlice } from "@reduxjs/toolkit";

const applyTheme = (theme) => {
  if (typeof window !== "undefined") {
    document.body.setAttribute("data-theme", theme);
    document.body.setAttribute("class", theme);
    document.body.style.colorScheme = theme;
    localStorage.setItem("theme", theme);
  }
};
if (window !== "undefined") {
  applyTheme(localStorage.getItem("theme"));
}

const savedTheme =
  typeof window !== "undefined" ? localStorage.getItem("theme") || "lightmode" : "lightmode";


const themeSlice = createSlice({
  name: "theme",
  initialState: {
    theme: savedTheme,
  },

  reducers: {
    setTheme: (state, action) => {
      state.theme = action.payload;
      applyTheme(action.payload);
    },

    toggleTheme: (state) => {
      const newTheme = state.theme === "darkmode" ? "lightmode" : "darkmode";
      state.theme = newTheme;
      applyTheme(newTheme);
    },
  },
});

export const { setTheme, toggleTheme } = themeSlice.actions;
export default themeSlice.reducer;
